import script from "./BaseListAndFormAso.vue?vue&type=script&setup=true&name=list&lang=js"
export * from "./BaseListAndFormAso.vue?vue&type=script&setup=true&name=list&lang=js"

import "./BaseListAndFormAso.vue?vue&type=style&index=0&id=61a9d7ff&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a9d7ff"]])

export default __exports__